import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/product/page";
import ContactsPage from "../pages/contacts/page";
import AboutPage from "../pages/about/page";
import CatalogPage from "../pages/catalog/page";
import CatalogSectionPage from "../pages/catalog/section/page";
import PromoPage from "../pages/promos/page";
import DeliveryPage from "../pages/delivery/page";
import LoyaltyPage from "../pages/loyalty/page";
import SearchPage from "../pages/search/page";
import ProfilePage from "../pages/profile/page";
import BlogPage from "../pages/blog/page";
import ArticlePage from "../pages/blog/article/page";
import CheckoutPage from "../pages/checkout/page";
import CheckoutSuccess from "../pages/checkout/success";
import PharmaciesPage from "../pages/pharmacies/page";
import PharmacyDetailPage from "../pages/pharmacies/pharmacy-detail/page";
import PromoDetailPage from "../pages/promos/detail/page";
import PromoSearchPage from "../pages/promos/search/page";
import SitemapPage from "../pages/sitemap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/contacts",
    element: <ContactsPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/catalog",
    element: <CatalogPage />,
  },
  {
    path: "/catalog/section/:slug",
    element: <CatalogSectionPage />,
  },
  {
    path: "/promos",
    element: <PromoPage />,
  },
  {
    path: "/promos/search",
    element: <PromoSearchPage />,
  },
  {
    path: "/promos/:id",
    element: <PromoDetailPage />,
  },
  {
    path: "/delivery",
    element: <DeliveryPage />,
  },
  {
    path: "/loyalty",
    element: <LoyaltyPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/checkout/success",
    element: <CheckoutSuccess />,
  },
  {
    path: "/pharmacies",
    element: <PharmaciesPage />,
  },
  {
    path: "/pharmacies/:id",
    element: <PharmacyDetailPage />,
  },
  {
    path: "/sitemap",
    element: <SitemapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
